import { InventorySummaryListPage } from "@/features/inventory-summary/pages/InventorySummaryListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-summary/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["inventory_summary.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventorySummaryListPage,
});
